import { FC } from "react";
import cx from "classnames";
import styles from "./styles.module.scss";
import SliderArrowIcon from "../../../icons/slider-arrow-icon";

export enum ArrowDirection {
  LEFT = "left",
  RIGHT = "right",
}

interface ICarCardImageButton {
  direction: ArrowDirection;
  onClick: () => void;
  className?: string;
}

const CarCardImageButton: FC<ICarCardImageButton> = ({ direction, onClick, className }) => {
  return (
    <button aria-label={"image gallery arrow"} className={cx(styles.arrowContainer, className)} onClick={onClick}>
      <SliderArrowIcon direct={direction === ArrowDirection.LEFT} />
    </button>
  );
};

export default CarCardImageButton;
